export default __webpack_public_path__ + "453ff68e04e7039c3e12f84d3c9b7de3.svg";